import { Box, CircularProgress } from '@mui/material';

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import React from 'react';

import { lazyRemote } from '../../../app/utils/lazy-remote';

export const Route = createFileRoute('/_auth/case-schedule/')({
  staticData: {
    title: 'pages.caseSchedule.title',
    description: 'pages.caseSchedule.description',
  },
  component: CaseScheduleIndex,
});

interface CaseSchedulePageProps {
  onNavigateToCase?: (caseId: string) => void;
}

const CaseSchedulePage = lazyRemote<CaseSchedulePageProps>(
  'peri_theatre/CaseSchedulePage'
);

function CaseScheduleIndex() {
  const navigate = useNavigate();

  return (
    <React.Suspense
      fallback={
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
          }}
        >
          <CircularProgress size={40} color="primary" />
        </Box>
      }
    >
      <CaseSchedulePage
        onNavigateToCase={(caseId) =>
          navigate({ to: '/case-schedule/case-detail', search: { caseId } })
        }
      />
    </React.Suspense>
  );
}
